import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { LOGIN_USER_INFO } from './url-constants';

type SecurityLoginUserInfoEndpointSpecifications = ApiEndpointSpecification;
export const SecurityLoginUserInfoEndpointSpecification: SecurityLoginUserInfoEndpointSpecifications = {
    url: LOGIN_USER_INFO,
    method: HttpMethod.POST,
    requestBodySchemaName: 'SecurityLoginRequestBody',
    okResponseSchemaName: 'SecurityLoginOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: false,
};

export const invokeSecurityLoginUserInfo = Helpers.makeApiRequestFn<
    {},
    Types.SecurityLoginUserInfoRequestBody,
    Types.SecurityLoginUserInfoOkResponse
>(SecurityLoginUserInfoEndpointSpecification);
